/* anvone PDP — vanilla JS. Plan state (sub/once), sticky ATC v2, expanders, qty, reveals.
   No framework. Money formatting uses the price strings already rendered by Liquid. */
(function () {
  'use strict';
  var root = document.getElementById('anv-pdp');
  if (!root) return;

  var state = { plan: 'sub' };
  var form = document.getElementById('anv-product-form');
  var planInput = root.querySelector('[data-anv-sellingplan]');
  var planValue = planInput ? planInput.value : null;

  /* ---------- helpers ---------- */
  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  var subPriceText = q('[data-anv-price]') ? q('[data-anv-price]').textContent : '';
  var oncePriceText = q('[data-anv-compare]') ? q('[data-anv-compare]').textContent : '';
  var ctaSubLabel = q('[data-anv-atc-label]') ? q('[data-anv-atc-label]').textContent : 'abo starten';

  function applyPlanState() {
    var isSub = state.plan === 'sub';
    if (planInput) planInput.disabled = !isSub;
    var label = q('[data-anv-atc-label]');
    var price = q('[data-anv-atc-price]');
    if (label) label.textContent = isSub ? ctaSubLabel : 'in den warenkorb';
    if (price) price.textContent = isSub ? subPriceText : oncePriceText;
    var onceToggle = q('[data-anv-once-toggle]');
    if (onceToggle) onceToggle.classList.toggle('is-active', !isSub);
    var card = q('[data-anv-plan-card]');
    if (card) card.classList.toggle('is-off', !isSub);
    /* sticky mirrors */
    var sPlan = q('[data-anv-sticky-plan]');
    var sPrice = q('[data-anv-sticky-price]');
    var sCompare = q('[data-anv-sticky-compare]');
    if (sPlan) sPlan.textContent = isSub ? 'abo' : 'einmaliger kauf';
    if (sPrice) sPrice.textContent = isSub ? subPriceText : oncePriceText;
    if (sCompare) sCompare.style.display = isSub ? '' : 'none';
    qa('[data-anv-opt]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-anv-opt') === state.plan);
    });
  }

  var onceToggle = q('[data-anv-once-toggle]');
  if (onceToggle) onceToggle.addEventListener('click', function () {
    state.plan = state.plan === 'sub' ? 'once' : 'sub';
    applyPlanState();
  });

  /* clicking the subscription card (re-)selects the abo */
  var planCard = q('[data-anv-plan-card]');
  if (planCard) planCard.addEventListener('click', function (e) {
    if (e.target.closest('[data-anv-expand]') || e.target.closest('[data-anv-plan]')) return;
    if (state.plan !== 'sub') { state.plan = 'sub'; applyPlanState(); }
  });

  /* frequency buttons → selling plan id */
  qa('[data-anv-plan]').forEach(function (b) {
    b.addEventListener('click', function () {
      qa('[data-anv-plan]').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      planValue = b.getAttribute('data-anv-plan');
      if (planInput) planInput.value = planValue;
      state.plan = 'sub';
      applyPlanState();
    });
  });

  /* ---------- qty ---------- */
  var qtyInput = q('[data-anv-qty-input]');
  var formQty = q('[data-anv-form-qty]');
  qa('[data-anv-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = parseInt(b.getAttribute('data-anv-qty'), 10);
      var v = Math.min(9, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d));
      qtyInput.value = v;
      if (formQty) formQty.value = v;
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () {
    var v = Math.min(9, Math.max(1, parseInt(qtyInput.value, 10) || 1));
    qtyInput.value = v;
    if (formQty) formQty.value = v;
  });

  /* ---------- expanders (gifts ⓘ + accordions) — grid-rows, zero layout shift ---------- */
  qa('[data-anv-expand]').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.closest('.anv-gifts__item, .anv-acc__item, .anv-secure__main');
      var panel = item ? item.querySelector('.anv-gifts__panel, .anv-acc__panel, .anv-secure__panel') : null;
      if (!panel) return;
      var open = panel.classList.toggle('open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- sticky bar ---------- */
  var sticky = q('[data-anv-sticky]');
  var buybox = q('.anv-pdp__buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      var past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sticky.classList.toggle('show', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      if (!past) {
        var sel = sticky.querySelector('[data-anv-sticky-selector]');
        var ch = sticky.querySelector('[data-anv-sticky-chip]');
        if (sel) sel.classList.remove('open');
        if (ch) ch.setAttribute('aria-expanded', 'false');
      }
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(buybox);
  }
  var chip = q('[data-anv-sticky-chip]');
  var selector = q('[data-anv-sticky-selector]');
  if (chip && selector) {
    chip.addEventListener('click', function () {
      var open = selector.classList.toggle('open');
      chip.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* fixed bottom-sheet mode (mobile): position the sheet flush above the bar, measured live */
      if (open && window.getComputedStyle(selector).position === 'fixed') {
        var barRect = sticky.getBoundingClientRect();
        selector.style.bottom = Math.max(0, window.innerHeight - barRect.top + 6) + 'px';
      }
    });
    qa('[data-anv-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.plan = b.getAttribute('data-anv-opt');
        selector.classList.remove('open');
        chip.setAttribute('aria-expanded', 'false');
        applyPlanState();
      });
    });
  }
  var stickyAtc = q('[data-anv-sticky-atc]');
  if (stickyAtc && form) stickyAtc.addEventListener('click', function () {
    var btn = q('[data-anv-atc]');
    if (btn) btn.click();
  });

  /* ---------- welcome-gift automation v2: atomic add (main + gifts) + Dawn drawer render ----------
     Capture-phase listener runs BEFORE Dawn's product-form handler; we take over the submit
     entirely when gifts are configured. Gifts only ship with the abo (welcome-kit is a sub perk). */
  var giftScript = q('[data-anv-gifts]');
  var giftVariants = [];
  try { giftVariants = giftScript ? JSON.parse(giftScript.textContent) : []; } catch (e) { giftVariants = []; }

  if (form && giftVariants.length) {
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var atc = q('[data-anv-atc]');
      var spinner = atc ? atc.querySelector('.loading__spinner') : null;
      if (atc) { atc.setAttribute('aria-disabled', 'true'); atc.classList.add('loading'); }
      if (spinner) spinner.classList.remove('hidden');

      var qty = parseInt((q('[data-anv-form-qty]') || {}).value, 10) || 1;
      var mainItem = { id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: qty };
      var isSub = state.plan === 'sub' && planInput && !planInput.disabled;
      if (isSub) mainItem.selling_plan = parseInt(planInput.value, 10);

      var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var present = {};
          (cart.items || []).forEach(function (i) { present[i.variant_id] = true; });
          var items = [mainItem];
          if (isSub) {
            giftVariants.forEach(function (g) {
              if (!present[g.id]) items.push({ id: g.id, quantity: 1, properties: { _anvone_welcome_gift: 'true' } });
            });
          }
          var body = { items: items };
          if (cartEl && cartEl.getSectionsToRender) {
            body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify(body)
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status && resp.status !== 200) { window.location.href = '/cart'; return; }
          if (cartEl && cartEl.renderContents) {
            cartEl.classList.remove('is-empty');
            cartEl.renderContents(resp);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          if (atc) { atc.removeAttribute('aria-disabled'); atc.classList.remove('loading'); }
          if (spinner) spinner.classList.add('hidden');
        });
    }, true);
  }

  /* ---------- mobile gallery slider ↔ thumbs ---------- */
  var track = q('[data-anv-track]');
  var thumbs = qa('[data-anv-thumb]');
  if (track && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-anv-thumb'), 10);
        var slide = q('[data-anv-slide="' + i + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }, 80);
    }, { passive: true });
  }

  /* ---------- UGC ambient videos: load + play only when visible ---------- */
  var autoVids = qa('[data-anv-ugc-auto]');
  if (autoVids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.15 });
    autoVids.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- UGC lightbox: click tile → big video with sound ---------- */
  var ugcTiles = qa('[data-anv-video]');
  if (ugcTiles.length) {
    var lb = document.createElement('div');
    lb.className = 'anv-lightbox';
    lb.innerHTML = '<button type="button" class="anv-lightbox__close" aria-label="schließen">×</button>';
    document.body.appendChild(lb);
    var lbVideo = null;
    function closeLb() {
      lb.classList.remove('open');
      if (lbVideo) { lbVideo.pause(); lbVideo.remove(); lbVideo = null; }
    }
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('anv-lightbox__close')) closeLb();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    ugcTiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (lbVideo) { lbVideo.remove(); }
        lbVideo = document.createElement('video');
        lbVideo.src = tile.getAttribute('data-anv-video');
        lbVideo.controls = true;
        lbVideo.autoplay = true;
        lbVideo.playsInline = true;
        lb.appendChild(lbVideo);
        lb.classList.add('open');
      });
    });
  }

  /* ---------- reveals (shared with anv-sections.js — first script to run claims it) ---------- */
  if (!window.__anvRevealDone) {
    window.__anvRevealDone = true;
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
      }, { threshold: 0.1 });
      qa('[data-anv-reveal]', document).forEach(function (n) { rio.observe(n); });
      /* fallback only for above-the-fold nodes that IO may have raced past — NOT the whole page,
         otherwise every below-fold section is already "in" before the user scrolls to it */
      setTimeout(function () {
        qa('[data-anv-reveal]', document).forEach(function (n) {
          if (n.getBoundingClientRect().top < window.innerHeight) n.classList.add('in');
        });
      }, 1600);
    } else {
      qa('[data-anv-reveal]', document).forEach(function (n) { n.classList.add('in'); });
    }
  }

  applyPlanState();
})();
